import { Badge, Col, FormGroup, Label } from 'twyne-new.ui'

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';
import DetailsModal from '@Components/modals/DetailsModal';

import { formatEntity, formatDate, formatModalFields, formatModalType, COLORS } from './utils';

export default function DetailsFormatter({ info }) {
  const { row } = getInfo(info)
  const id = keyOf(info, 'details')

  return <DetailsModal id={id} title='Data Extractor Details'>
    {Object.entries(row).map(([key, value]) => <DetailsModalItem key={key} label={key} value={value} />)}
  </DetailsModal>
}

function DetailsModalItem({ label, value }) {
  if (value === '' || !['id', 'site', 'user', 'meta', 'dataType', 'status', 'expireAt'].includes(label)) {
    return null
  }

  if (label === 'meta') {
    return <>
      {Object.entries(value || {}).map(([metaLabel, metaValue]) => {
        if (!metaValue || !['configuration', 'pagination'].includes(metaLabel)) {
          return null
        }

        if (metaLabel === "configuration") {
          return <>
            {Object.entries(metaValue).map(([fieldLabel, fieldValue]) => {
              if (fieldValue === '' || !['fields', 'filters', 'startAt', 'endAt', 'credential'].includes(fieldLabel)) {
                return null
              }

              if (['startAt', 'endAt'].includes(fieldLabel)) {
                fieldValue = formatDate(fieldValue)
              }

              if (['fields', 'filters'].includes(fieldLabel)) {
                fieldValue = formatModalFields(fieldValue)
              }

              return <Col key={fieldLabel} size="6">
                <FormGroup>
                  <Label>{fieldLabel}</Label>
                  <span className='twy-text-base-accent'>{fieldValue === true || fieldValue === false ? `${fieldValue}` : fieldValue || '--'}</span>
                </FormGroup>
              </Col>
            })}
          </>
        }

        if (metaLabel === "pagination") {
          metaValue = formatModalFields(metaValue)
        }

        return <Col key={metaLabel} size="6">
          <FormGroup>
            <Label>{metaLabel}</Label>
            <span className='twy-text-base-accent'>{metaValue}</span>
          </FormGroup>
        </Col>
      })}
    </>
  }

  if (['expireAt'].includes(label)) {
    value = formatDate(value)
  }

  if (['site', 'user'].includes(label)) {
    value = formatEntity(value)
  }

  if (label === 'dataType') {
    value = formatModalType(value)
  }

  if (label === 'status') {
    value = <Badge color={COLORS[value]} size='sm'>
      {value}
    </Badge>
  }

  return <Col size="6">
    <FormGroup>
      <Label>{label}</Label>
      <span className='twy-text-base-accent'>{value === true || value === false ? `${value}` : value || '--'}</span>
    </FormGroup>
  </Col>
}
